<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search"
               @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
      <el-col :md="6" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询
              </el-button>
              <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 操作按钮 -->
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small" v-if="permission.includes('sys:mpuseropeninfo:add')">添加
        </el-button>
        <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small" v-if="permission.includes('sys:mpuseropeninfo:dall')">批量删除
        </el-button>
      </div>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)" highlight-current-row>
        <template slot-scope="{index}">
          <el-table-column type="selection" width="45" align="center" fixed="left"/>
          <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left" show-overflow-tooltip/>
                  
          <el-table-column prop="user_id" label="" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="user_code" label="会员号" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="deal_num" label="交易量" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="grade" label="会员等级" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="openid" label="用户openid" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="real_name" label="真实姓名" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="id_card" label="身份证号" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="nick_name" label="用户昵称" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="gender" label="用户性别" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="province" label="用户省份" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="city" label="用户城市" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="invite_code" label="邀请码" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="use_invite_code" label="所用邀请码" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="red_num" label="红包金额" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="integral" label="积分" sortable="custom" show-overflow-tooltip min-width="120"/>
                  
          <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
          </el-table-column>
          <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
          </el-table-column>
          <el-table-column label="操作" width="130px" align="center" :resizable="false"  fixed="right">
            <template slot-scope="{row}">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false" v-if="permission.includes('sys:mpuseropeninfo:edit')">修改</el-link>
              <el-popconfirm title="确定要删除此用户公开信息吗？" @confirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false" v-if="permission.includes('sys:mpuseropeninfo:delete')">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog :title="editForm.id?'修改用户公开信息':'修改用户公开信息'" :visible.sync="showEdit" width="450px"
               @closed="editForm={}" :destroy-on-close="true" :lock-scroll="false" :close-on-click-modal="false">
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
                          
        <el-form-item label="：" prop="user_id">
            <el-input-number v-model="editForm.user_id" controls-position="right" :min="0"
                              placeholder="请输入" class="ele-fluid ele-text-left"/>
        </el-form-item>
                                                      
        <el-form-item label="会员号：" prop="user_code">
            <el-input-number v-model="editForm.user_code" controls-position="right" :min="0"
                              placeholder="请输入会员号" class="ele-fluid ele-text-left"/>
        </el-form-item>
                                                      
        <el-form-item label="交易量：" prop="deal_num">
            <el-input-number v-model="editForm.deal_num" controls-position="right" :min="0"
                              placeholder="请输入交易量" class="ele-fluid ele-text-left"/>
        </el-form-item>
                                                      
        <el-form-item label="会员等级：" prop="grade">
            <el-input-number v-model="editForm.grade" controls-position="right" :min="0"
                              placeholder="请输入会员等级" class="ele-fluid ele-text-left"/>
        </el-form-item>
                                                      
        <el-form-item label="用户openid：" prop="openid">
            <el-input v-model="editForm.openid" placeholder="请输入用户openid" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="真实姓名：" prop="real_name">
            <el-input v-model="editForm.real_name" placeholder="请输入真实姓名" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="身份证号：" prop="id_card">
            <el-input v-model="editForm.id_card" placeholder="请输入身份证号" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="用户昵称：" prop="nick_name">
            <el-input v-model="editForm.nick_name" placeholder="请输入用户昵称" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="用户性别：" prop="gender">
            <el-input-number v-model="editForm.gender" controls-position="right" :min="0"
                              placeholder="请输入用户性别" class="ele-fluid ele-text-left"/>
        </el-form-item>
                                                      
        <el-form-item label="用户省份：" prop="province">
            <el-input v-model="editForm.province" placeholder="请输入用户省份" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="用户城市：" prop="city">
            <el-input v-model="editForm.city" placeholder="请输入用户城市" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="邀请码：" prop="invite_code">
            <el-input v-model="editForm.invite_code" placeholder="请输入邀请码" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="所用邀请码：" prop="use_invite_code">
            <el-input v-model="editForm.use_invite_code" placeholder="请输入所用邀请码" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="红包金额：" prop="red_num">
            <el-input-number v-model="editForm.red_num" controls-position="right" :min="0"
                              placeholder="请输入红包金额" class="ele-fluid ele-text-left"/>
        </el-form-item>
                                                      
        <el-form-item label="积分：" prop="integral">
            <el-input-number v-model="editForm.integral" controls-position="right" :min="0"
                              placeholder="请输入积分" class="ele-fluid ele-text-left"/>
        </el-form-item>
                              
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit=false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SysMpUserOpeninfo",
  data() {
    return {
      table: {url: '/mpuseropeninfo/index', where: {}},  // 表格配置
      choose: [],  // 表格选中数据
      showEdit: false,  // 是否显示表单弹窗
      editForm: {},  // 表单数据
      editRules: {  // 表单验证规则
              
        user_id: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
                          
        user_code: [
          {required: true, message: '请输入会员号', trigger: 'blur'}
        ],
                          
        deal_num: [
          {required: true, message: '请输入交易量', trigger: 'blur'}
        ],
                          
        grade: [
          {required: true, message: '请输入会员等级', trigger: 'blur'}
        ],
                                    
        openid: [
          {required: true, message: '请输入用户openid', trigger: 'blur'}
        ],
                                    
        real_name: [
          {required: true, message: '请输入真实姓名', trigger: 'blur'}
        ],
                                    
        id_card: [
          {required: true, message: '请输入身份证号', trigger: 'blur'}
        ],
                                    
        nick_name: [
          {required: true, message: '请输入用户昵称', trigger: 'blur'}
        ],
                          
        gender: [
          {required: true, message: '请输入用户性别', trigger: 'blur'}
        ],
                                    
        province: [
          {required: true, message: '请输入用户省份', trigger: 'blur'}
        ],
                                    
        city: [
          {required: true, message: '请输入用户城市', trigger: 'blur'}
        ],
                                    
        invite_code: [
          {required: true, message: '请输入邀请码', trigger: 'blur'}
        ],
                                    
        use_invite_code: [
          {required: true, message: '请输入所用邀请码', trigger: 'blur'}
        ],
                          
        red_num: [
          {required: true, message: '请输入红包金额', trigger: 'blur'}
        ],
                          
        integral: [
          {required: true, message: '请输入积分', trigger: 'blur'}
        ],
              
      },
    }
  },
computed: {
    ...mapGetters(["permission"]),
},
  mounted() {
  },
  methods: {
    /**
     * 显示编辑
     */
    edit(row) {
      this.$http.get('/mpuseropeninfo/info?id=' + row.id).then(res => {
        if (res.data.code === 0) {
          this.editForm = res.data.data;
          this.showEdit = true;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    },
    /**
     * 保存编辑
     */
    save() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({lock: true});
          this.$http.post('/mpuseropeninfo/edit', this.editForm).then(res => {
            loading.close();
            if (res.data.code === 0) {
              this.showEdit = false;
              this.$message({type: 'success', message: res.data.msg});
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            loading.close();
            this.$message.error(e.message);
          });
        } else {
          return false;
        }
      });
    },
    /**
     * 刪除(批量刪除)
     */
    remove(row) {
      console.log(row)
      if (!row) {  // 批量删除
        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
        let ids = this.choose.map(d => d.id);
        this.$confirm('确定要删除选中的用户公开信息吗?', '提示', {type: 'warning'}).then(() => {
          const loading = this.$loading({lock: true});
          this.$http.post('/mpuseropeninfo/delete', {id: ids}).then(res => {
            loading.close();
            if (res.data.code === 0) {
              this.$message({type: 'success', message: res.data.msg});
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            loading.close();
            this.$message.error(e.message);
          });
        }).catch(() => 0);
      } else {  // 单个删除
        const loading = this.$loading({lock: true});
        this.$http.post('/mpuseropeninfo/delete', {id:row.id}).then(res => {
          loading.close();
          if (res.data.code === 0) {
            this.$message({type: 'success', message: res.data.msg});
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          loading.close();
          this.$message.error(e.message);
        });
      }
    },
                                                                }
}
</script>

<style scoped>
.ele-block >>> .el-upload, .ele-block >>> .el-upload-dragger {
  width: 100%;
}
</style>